import styled from '@emotion/styled';
import { tabs } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

export const TabsWrapper = styled('nav', { label: 'TabsWrapper' })`
    margin-bottom: 16px;
    border-bottom: 3px solid ${tabs.slider.borderColor};
`;

interface TabItemType {
    isActive?: boolean
}

export const TabItem = styled('button', { label: 'TabItem' })<TabItemType>`
    font-family: var(--fontFamilyPrimary);
    background: transparent;
    border: none;
    color: ${({ isActive }): string => isActive === true ? tabs.slider.txtColor : tabs.slider.txtColorSecondary};
    cursor: pointer;
    font-size: ${fontSize.xRegular};
    font-weight: ${({ isActive }): string => isActive === true ? fontWeight.bold : fontWeight.regular};
    line-height: 1.172;
    outline: none;
    padding: 8px 8px 12px 8px;
    position: relative;
    &:first-of-type {
        margin-left: 0;
    }
    &::after {
        ${({ isActive }): string => isActive === true ? 'content: ""' : 'content: none'};
        background: ${tabs.slider.bgColor};
        height: 3px;
        left: 0;
        position: absolute;
        right: 0;
        top: 100%;
    }
`;

export const FormHeaderWrapper = styled('div', { label: 'FormHeaderWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 8px 0 24px;
`;

export const TabsWrapperSecondary = styled('div', { label: 'TabsWrapperSecondary' })`
    border: 1px solid ${tabs.box.borderColor};
    width: max-content;
`;

export const TabItemSecondary = styled(TabItem, { label: 'TabItemSecondary' })`
    padding: 8px;
    margin: 0;
    background: ${({ isActive }): string => isActive === true ? tabs.box.bgColor : 'transparent'};
    color: ${({ isActive }): string => isActive === true ? tabs.box.txtColor : tabs.box.txtColorSecondary};

    &::after {
        content: none;
    }

    &:disabled {
        color: ${({ isActive }): string => isActive === true ? tabs.box.txtColor : tabs.box.txtColorSecondary};
    }

    &:first-of-type {
        margin-right: 8px;
    }
`;
